const variantName = 'spinnerContainer'

export default {
  [variantName]: {
    justifyContent: 'center'
  }
}
